import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import { FaPlus } from "react-icons/fa";
const AbdominalUltrasoundModal = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const[isLoading,setIsLoading]=useState(false)
    const [providerList, setProviderList] = useState([]);
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
    const [showGallbladderComment, setShowGallbladderComment] = useState(false);
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
const practiseid = window.getPracticeId();
  const initialFormState = {
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    aorta: { value: "", unit: "cm" },
    ivc: { value: "", unit: "cm" },
    liver: { value: "", unit: "cm" },
    cbd: { value: "", unit: "cm" },
    gallbladderRemoved: false,
    gallbladder: { value: "", unit: "cm",   comment: "",},
    pancreas: { value: "", unit: "cm" },
    rtKidney: { L: "", W: "", H: "", unit: "cm" },
    ltKidney: { L: "", W: "", H: "", unit: "cm" },
    spleen: { value: "", unit: "cm" },
    impression: "",
    signature: "",
  };

  const [formData, setFormData] = useState(initialFormState);
useEffect(() => {
  if (ismodal) {
    getProviders();
  }
}, [ismodal]);
const getProviders = async () => {
  try {
    const response = await api.get(`/v1/${practiseid}/providers`);
    if (response.status === 200 && Array.isArray(response.data)) {
      setProviderList(response.data);
    }
  } catch (error) {
    console.error("Error fetching providers:", error);
    setToastMessage("Failed to load providers");
    setToastSeverity("error");
    setOpenToast(true);
  }
};
  const resetFormData = () => {
    setFormData(initialFormState);
  };
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);
  const handleChange = (section, field, value) => {
    if (["aorta", "ivc", "liver", "cbd", "gallbladder", "pancreas", "spleen"].includes(section)) {
      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else if (section === "rtKidney" || section === "ltKidney") {
      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else if (field === "gallbladderRemoved") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        gallbladder: value ? { value: "", unit: "cm" } : prev.gallbladder,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.aorta.value) errors.push("Aorta is required.");
    if (!formData.ivc.value) errors.push("IVC is required.");
    if (!formData.liver.value) errors.push("Liver is required.");
    if (!formData.cbd.value) errors.push("CBD is required.");
    if (!formData.gallbladderRemoved && !formData.gallbladder.value) errors.push("Gallbladder is required.");
    if (!formData.pancreas.value) errors.push("Pancreas is required.");
    if (!formData.rtKidney.L || !formData.rtKidney.W || !formData.rtKidney.H) errors.push("All Rt Kidney fields are required.");
    if (!formData.ltKidney.L || !formData.ltKidney.W || !formData.ltKidney.H) errors.push("All Lt Kidney fields are required.");
    if (!formData.spleen.value) errors.push("Spleen is required.");
    if (!formData.impression.trim()) errors.push("Impression is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
   try {
    setIsLoading(true)
      const selectedProvider = providerList.find(
  (p) => p.providername === formData.provider
);

    let payload={
...formData,
 patient_id: data?.patientid,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      pathistory: formData.history,
      providername: formData.provider,
       providerid:  selectedProvider?.providerid,
      pat_age: age,
      pat_gender: data?.gender?.toUpperCase(),
    }
  
          const user=await api.get('/auth/me')
    const [year, month, day] = formData.examDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;

const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
  "Worksheet_Type": "ABDOMINAL_ULTRASOUND",
  "createdby": user?.username || '',
   "appurl": window.location.origin,
  //  "appurl": "",
  "Exam_Date": formattedDate,
  "data":payload
});

if(response.status==200){
  const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
  "filename": response?.data?.filename,
// "appurl": "",
  "worksheet_type": "ABDOMINAL_ULTRASOUND",
   "appurl": window.location.origin,
  "exam_date": formattedDate
  })
  setToastMessage("Form Submitted Successfully");
    setToastSeverity("success");
    setOpenToast(true);
 setTimeout(() => {
  resetFormData()
  setIsmodal(false);
}, 1000);

}else{
  setToastMessage(response.message);
    setToastSeverity("info");
    setOpenToast(true);
}
   } catch (error) {
    console.log(error)
   }finally{
setIsLoading(false)
   }
    }
  };

  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">ABDOMINAL ULTRASOUND</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
             #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Date of Birth:</span> {formattedDOB}</div>
            <div className="text-sm text-gray-700"><span className="font-semibold">Age:</span> {age}  | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
               <select
  className="w-full border rounded px-2 py-1"
  value={formData.provider}
  onChange={(e) => handleChange(null, "provider", e.target.value)}
>
  <option value="">Select Provider</option>
  {providerList.map((provider) => (
    <option key={provider.id} value={provider.providername}>
      {provider.providername}
    </option>
  ))}
</select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={formData.examDate} onChange={(e) => handleChange(null, "examDate", e.target.value)} />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea placeholder="Enter Patient History here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.history} onChange={(e) => handleChange(null, "history", e.target.value)} />
        </div>

        {["aorta", "ivc", "liver", "cbd"].map((section) => (
          <div key={section} className="flex gap-4 mt-4 items-center">
            <label className="block text-sm font-medium min-w-[60px]">{section.toUpperCase()}</label>
            <div className="flex items-center gap-4 flex-1">
              <input  type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[section].value} onChange={(e) => handleChange(section, "value", e.target.value)} />
              <label className="text-sm text-gray-600">Units:</label>
              <select className="border rounded px-2 py-1" value={formData[section].unit} onChange={(e) => handleChange(section, "unit", e.target.value)}>
                <option>cm</option>
                <option>mm</option>
              </select>
            </div>
          </div>
        ))}

        <div className="mt-4">
          <label className="flex items-center mb-4">
            <input type="checkbox" checked={formData.gallbladderRemoved} onChange={(e) => handleChange(null, "gallbladderRemoved", e.target.checked)} />
            <span className="ml-2 text-sm font-medium">Cholecystectomy (Gallbladder removed)</span>
          </label>

      <div className="mt-2 space-y-4">
      {["gallbladder", "pancreas"].map((section) => (
        <div key={section}>
          <div className="flex gap-4 items-center">
            <label className="block text-sm font-medium min-w-[100px]">
              {section.toUpperCase()}
            </label>
            <div className="flex items-center gap-4 flex-1">
              <input
                type="number"
                step="0.01"
                inputMode="decimal"
                className="border rounded px-2 py-1 w-full"
                value={formData[section].value}
                onChange={(e) =>
                  handleChange(section, "value", e.target.value)
                }
                disabled={
                  section === "gallbladder" && formData.gallbladderRemoved
                }
              />
              <select
                className="border rounded px-2 py-1"
                value={formData[section].unit}
                onChange={(e) =>
                  handleChange(section, "unit", e.target.value)
                }
              >
                <option>cm</option>
                <option>mm</option>
              </select>

              {/* FaPlus only for gallbladder */}
              {section === "gallbladder" && (
                <FaPlus
                  className="cursor-pointer bg-gray-200 rounded-full p-1"
                  onClick={() =>
                    setShowGallbladderComment((prev) => !prev)
                  }
                />
              )}
            </div>
          </div>

          {/* Conditionally show textarea for gallbladder */}
          {section === "gallbladder" && showGallbladderComment && (
            <div className="ml-[100px] mt-2">
              <textarea
                placeholder="Enter comment for gallbladder..."
                className="w-full border rounded px-2 py-1"
                value={formData.gallbladder.comment}
                onChange={(e) =>
                  handleChange("gallbladder", "comment", e.target.value)
                }
              />
            </div>
          )}
        </div>
      ))}
    </div>
        </div>

        {["rtKidney", "ltKidney"].map((section) => (
          <div key={section} className="mt-4">
            <div className="grid grid-cols-4 gap-4 text-sm font-medium mb-1">
              <span>{section === "rtKidney" ? "Rt Kidney" : "Lt Kidney"}</span>
              <span>{section === "rtKidney" ? "Rt Kidney" : "Lt Kidney"}</span>
              <span>{section === "rtKidney" ? "Rt Kidney" : "Lt Kidney"}</span>
              <span>Unit</span>
            </div>
            <div className="grid grid-cols-4 gap-4">
              <input  type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[section].L} onChange={(e) => handleChange(section, "L", e.target.value)} />
              <input  type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[section].W} onChange={(e) => handleChange(section, "W", e.target.value)} />
              <input  type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData[section].H} onChange={(e) => handleChange(section, "H", e.target.value)} />
              <select className="border rounded px-2 py-1 w-full" value={formData[section].unit} onChange={(e) => handleChange(section, "unit", e.target.value)}>
                <option>cm</option>
                <option>mm</option>
              </select>
            </div>
          </div>
        ))}

        <div className="mt-4">
          <label className="block text-sm font-medium mb-2">Spleen</label>
          <div className="grid grid-cols-2 gap-4">
            <input  type="number"
  step="0.01"
  inputMode="decimal" className="border rounded px-2 py-1 w-full" value={formData.spleen.value} onChange={(e) => handleChange("spleen", "value", e.target.value)} />
            <select className="border rounded px-2 py-1 w-full" value={formData.spleen.unit} onChange={(e) => handleChange("spleen", "unit", e.target.value)}>
              <option>cm</option>
              <option>mm</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Sonographer's Impression Not Official Report</label>
          <textarea placeholder="Enter Sonographer's Impression here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.impression} onChange={(e) => handleChange(null, "impression", e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input className="w-full border rounded px-2 py-1 mt-1" placeholder="Signature" value={formData.signature} onChange={(e) => handleChange(null, "signature", e.target.value)} />
        </div>

        <div className="flex justify-end gap-3 mt-6">
     
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
 <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
  </Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default AbdominalUltrasoundModal;
